const FALLBACK_IMAGE = "/icon.png"

export function timeAgo(timestamp: string | null): string {
  if (!timestamp) return ""

  const date = new Date(timestamp)
  const now = new Date()
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000)

  if (seconds < 0 || seconds < 60) return "now"

  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m`

  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h`

  const days = Math.floor(hours / 24)
  if (days < 14) return `${days}d`

  return date.toLocaleDateString("en-US", { month: "short", day: "numeric" })
}

export function recipePreviewImage(url: string | null): string {
  return url || FALLBACK_IMAGE
}

export function recipeForkRating(score: number): number {
  if (score <= 0) return 0
  const rating = Math.round(1 + 2 * Math.log10(score))
  return Math.min(Math.max(rating, 0), 5)
}

export function recipeForks(score: number): string {
  const rating = recipeForkRating(score)
  return "🍴".repeat(rating)
}

export function formatAdminTimestamp(value: string | null): string | null {
  if (!value) return null
  return new Date(value).toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    timeZoneName: "short",
  })
}

export function formatDate(value: string | null): string {
  if (!value) return "—"
  return new Date(value).toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
  })
}

export function distanceOfTimeInWordsToNow(timestamp: string | null): string {
  if (!timestamp) return "—"

  const date = new Date(timestamp)
  const now = new Date()
  const seconds = Math.floor((now.getTime() - date.getTime()) / 1000)
  const minutes = Math.floor(seconds / 60)
  const hours = Math.floor(minutes / 60)
  const days = Math.floor(hours / 24)

  if (seconds < 60) return "less than a minute ago"
  if (minutes === 1) return "1 minute ago"
  if (minutes < 60) return `${minutes} minutes ago`
  if (hours === 1) return "about 1 hour ago"
  if (hours < 24) return `about ${hours} hours ago`
  if (days === 1) return "1 day ago"
  return `${days} days ago`
}
